import { useLayoutEffect, useState } from "react";

export const useHasHydrated = () => {
	const [hasHydrated, setHasHydrated] = useState(false);
	const useBrowserLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : () => {};

	useBrowserLayoutEffect(() => {
		setHasHydrated(true);
	}, []);

	return hasHydrated;
};
